const PeiAnalysisAlternatePlacements = {
  SuplementaryServices: 1927,
};

export default PeiAnalysisAlternatePlacements;
